import {ColumnPropertyLazySelect} from "../../../../types/records-table.types";
import {ResourceParams, resources} from "../../../../models/resource/resources";

export const bankDetailsResourceType: ResourceParams = resources['bank-details'];
export const bankDetailsFieldName: string = 'bankDetails';

export const dateFields = ['grandDate', 'birthDate'];

export const propertyLazySelectBankDetails: ColumnPropertyLazySelect = {
  recourseName: 'LegalEntityType',
  providerType: 'DEFAULT'
}

export const unbindBankDetailsConfirmationParams = {
  titleText: 'Отвязать реквизиты',
  description: 'Вы действительно хотите отвязать реквизиты?',
  buttonWarmText: 'Отвязать'
}

export const deleteBankDetailsConfirmationParams = {
  titleText: 'Удалить реквизиты',
  description: 'Вы действительно хотите удалить реквизиты?',
  buttonWarmText: 'Удалить',
}
